<template>
    <div class="w-full px-4 py-4 mb-4 font-medium border-2 rounded-lg bg-marketing-blue-faq border-brand-blue-dark lg:px-6">
        <dt class="flex flex-row items-center cursor-pointer" @click="toggleTranscript" role="button" :id="id">
            <div class="pr-4 text-lg text-brand-blue-dark">
                <small v-show="open"><i class="fas fa-minus"></i></small>
                <small v-show="!open"><i class="fas fa-plus"></i></small>
            </div>
            <slot name="question"></slot>
        </dt>

        <div class="leading-tight faq-answer lg:leading-snug expandable" :class="{ 'is-expanded': open }">
            <dd>
                <slot></slot>
            </dd>
        </div>
    </div>
</template>

<script>
    export default {
        props: {
            question: String,
            id: String,
        },

        data() {
            return {
                open: false
            }
        },

        methods: {
            toggleTranscript() {
                this.open = ! this.open;
            },
        }
    }
</script>

<style scoped>
.expandable {
    height: 0px;
    overflow: hidden;
    opacity: 0;
    transition: all .15s ease-in-out;
}

.expandable.is-expanded {
    padding-top: .5rem;
    height: auto;
    opacity: 1;
}
</style>
